<section id="section-report" class="container-fluid mt-lg-2">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table" class="mt-1">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{costAdjustmentPrintModel.costAdjustmentId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{costAdjustmentPrintModel.costAdjustmentId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  <!-- Inventario  -->
                  <label id="t-inventario-{{costAdjustmentPrintModel.costAdjustmentId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-inventario' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="inventario-{{costAdjustmentPrintModel.costAdjustmentId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{costAdjustmentPrintModel.inventoryName}}</p>

                  <!--Nombre Sucursal -->
                  <label id="t-sucursal-{{costAdjustmentPrintModel.costAdjustmentId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-sucursal'
                    | formatLabelPipe : elementsLabel}}</label>

                  <p id="nombre-sucursal-{{costAdjustmentPrintModel.costAdjustmentId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{costAdjustmentPrintModel.branchName}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{costAdjustmentPrintModel.costAdjustmentId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-direccion'
                    | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{costAdjustmentPrintModel.costAdjustmentId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{costAdjustmentPrintModel.address}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{costAdjustmentPrintModel.costAdjustmentId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-{{costAdjustmentPrintModel.costAdjustmentId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{costAdjustmentPrintModel.phone}}</p>

                  <!--Nombre Ajuste Costos -->
                  <p id="nombre-ajuste-costos-{{costAdjustmentPrintModel.costAdjustmentId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'AJUSTE COSTOS Nro.'+ costAdjustmentPrintModel.consecutive}}</p>

                  <!-- Fecha Ajuste Costos -->
                  <label id="t-fecha-ajuste-costos-{{costAdjustmentPrintModel.costAdjustmentId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-ajuste-costos' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-ajuste-costos-{{costAdjustmentPrintModel.costAdjustmentId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{costAdjustmentPrintModel.dateCostAdjustment | date: 'dd/MM/yyyy'}}</p>

                  <!-- Proveedor  -->
                  <label id="t-proveedor-{{costAdjustmentPrintModel.costAdjustmentId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-proveedor' | formatLabelPipe :
                    elementsLabel}}</label>

                  <p id="proveedor-{{costAdjustmentPrintModel.costAdjustmentId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{costAdjustmentPrintModel.provider}}</p>

                  <!-- Remisión  -->
                  <label id="t-remision-{{costAdjustmentPrintModel.costAdjustmentId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-remision' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="remision-{{costAdjustmentPrintModel.costAdjustmentId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{costAdjustmentPrintModel.remission}}</p>

                  <!-- Factura  -->
                  <label id="t-factura-{{costAdjustmentPrintModel.costAdjustmentId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-factura' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="factura-{{costAdjustmentPrintModel.costAdjustmentId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{costAdjustmentPrintModel.invoice}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-ajuste-costos-{{ costAdjustmentPrintModel.costAdjustmentId }}"
                  [columns]="columns" [data]="costAdjustmentPrintModel.costAdjustmentDetails" [idMap]="idMap"
                  [documentId]="costAdjustmentPrintModel.costAdjustmentId" [footerVisible]="true"
                  [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <!-- Observaciones -->
              <div id="foot-{{costAdjustmentPrintModel.costAdjustmentId}}" class="foot mt-3 container-observations">
                <label id="t-observacion-ajuste-costos-{{costAdjustmentPrintModel.costAdjustmentId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="costAdjustmentPrintModel.observation">{{'t-observacion-ajuste-costos' |
                  formatLabelPipe : elementsLabel}}</label>
                <p id="observacion-ajuste-costos-{{costAdjustmentPrintModel.costAdjustmentId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="costAdjustmentPrintModel.observation">
                  {{costAdjustmentPrintModel.observation}}</p>

                <!-- Firma Revisado-->
                <p id="linea-firma-revisado-{{costAdjustmentPrintModel.costAdjustmentId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-revisado-{{costAdjustmentPrintModel.costAdjustmentId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-linea-revisado' | formatLabelPipe :
                  elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>